<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="openBadge">
    <Dialog class="relative z-50" @close="closeDialogBadge">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Cadastro de Marcações</h2>
                <button @click="closeDialogBadge" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                  
                  <!-- Status Comercial Filter -->
                  <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2 mb-4">
                    <label for="status_comercial" class="block text-sm font-medium text-gray-900">Nome</label>
                    <select
                      id="status_comercial"
                      name="status_comercial"
                      v-model="data.nome"
                      class="mt-2 block w-full rounded-md border border-gray-300 py-2 px-3 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    >
                      <option value="">Não se Aplica</option>
                      <option value="Cancelamento recente">Cancelamento recente</option>
                      <option value="Capital máximo">Capital máximo</option>
                      <option value="Contato incorreto">Contato incorreto</option>
                      <option value="Contratou recentemente">Contratou recentemente</option>
                      <option value="Envio de WhatsApp">Envio de WhatsApp</option>
                      <option value="Falecido">Falecido</option>
                      <option value="Inadimplente">Inadimplente</option>
                      <option value="Não é mais associado">Não é mais associado</option>
                      <option value="Não quer mais contato">Não quer mais contato</option>
                      <option value="Pós venda">Pós venda</option>
                      <option value="Sem interesse">Sem interesse</option>
                      <option value="Sem margem para desconto">Sem margem para desconto</option>
                      <option value="Sem número para contato">Sem número para contato</option>
                      <option value="Tentativa de contato sem sucesso">Tentativa de contato sem sucesso</option>
                    </select>
                  </div>

                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">Cadastrar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

  export default {
    name: 'CommonForm',
    async created(){
        
    },
    props: {
      openBadge: {
        type: Boolean,
        required: true
      },
    },  
    watch: {
      
    }, 
    data() {
      return {
        data:{},
      };
    },
    methods: {
      sendData(e) {
        e.preventDefault();
        this.$emit('data-badge', this.data);
      },
      closeDialogBadge() {
        this.$emit('update-open-badge', false);  // Emite um evento para o componente pai alterar a prop "open"
      },
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
    },
  }
</script>